export enum HolidayActionType {
	FETCH_HOLIDAYS = 'FETCH_HOLIDAYS',
	STORE_HOLIDAYS = 'STORE_HOLIDAYS',
	ERROR_HOLIDAYS = 'ERROR_HOLIDAYS',

	ADD_HOLIDAY = 'ADD_HOLIDAY',
	DELETE_HOLIDAY = 'DELETE_HOLIDAY',
	UPDATE_HOLIDAY = 'UPDATE_HOLIDAY',

}
